import { ensureModuleMessages, registerModuleCatalog } from '@/shared/i18n/i18n';

// A07: catálogo `eager` para o título do manifesto sair traduzido no ⌘K e no breadcrumb.
registerModuleCatalog('system-application', (locale) => import(`./locales/${locale}.po`), {
  eager: true,
});

export const loadSystemApplicationMessages = () => ensureModuleMessages('system-application');
